export default __webpack_public_path__ + "static/media/logo.a784e519.png";